import { MaskedLine } from "@/components/Reveal";

export default function PageHero({ overline, title, image }) {
  return (
    <section className="relative flex min-h-[52vh] items-end overflow-hidden bg-navy pb-16 pt-40">
      {image && (
        <>
          <div className="absolute inset-0 bg-cover bg-center opacity-40" style={{ backgroundImage: `url('${image}')` }} />
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-navy/30" />
        </>
      )}
      <div className="relative mx-auto w-full max-w-7xl px-5 lg:px-10">
        <MaskedLine>
          <span className="overline-label !text-gold">{overline}</span>
        </MaskedLine>
        <MaskedLine delay={0.12}>
          <h1 className="mt-4 font-display text-4xl tracking-tight text-sand sm:text-5xl lg:text-6xl">{title}</h1>
        </MaskedLine>
      </div>
    </section>
  );
}
